export default __webpack_public_path__ + "static/media/Graph-stock.5f8725bd.svg";